import React from "react"
import FormRender from "./component/FormRender"
import { changeFormData, changeSelected, form_data, set_dial_code_selected } from "signals/form"
import FormSelect from "./component/FormSelect"
import { get_cities, get_districts, get_provinces } from "services/region"
import { cities, countries, districts, provinces } from "signals/region"
import FormRadio from "./component/FormRadio"

const ListField = ({ name, type, sort, ...props }) => {
	const { country, province, country_dial_code } = form_data.value

	const handleChange = (e, key) => {
		const { value } = e.target
		changeFormData(key, value)
	}

	const handleSelect = (e, key) => {
		const { value } = e
		changeFormData(key, value);
		switch (key) {
			case "country":
				get_provinces({ country_code: value })
				set_dial_code_selected(value)
				changeSelected("province", "")
				changeSelected("city", "")
				changeSelected("district", "")
				changeSelected("postal_code", "")
				changeFormData("province", "")
				changeFormData("city", "")
				changeFormData("district", "")
				changeFormData("postal_code", "")
				break
			case "province":
				get_cities({ country_code: country, province_code: value })
				changeSelected("city", "")
				changeSelected("district", "")
				changeSelected("postal_code", "")
				changeFormData("city", "")
				changeFormData("district", "")
				changeFormData("postal_code", "")
				break
			case "city":
				get_districts({ country_code: country, province_code: province, city_code: value })
				changeSelected("district", "")
				changeSelected("postal_code", "")
				changeFormData("district", "")
				changeFormData("postal_code", "")
				break
			case "district":
				changeSelected("postal_code", "")
				changeFormData("postal_code", "")
				break
			default:
			// code block
		}
	}

	const listOptions = {
		country: {
			options: countries.value,
		},
		province: {
			options: provinces.value,
			disabled: "country",
		},
		city: {
			options: cities.value,
			disabled: "province",
		},
		district: {
			options: districts.value,
			disabled: "city",
		},
		country_dial_code: {
			options: countries.value,
		},
	}

	const renderType = () => {
		switch (type) {
			case "select":
				const option = listOptions[name]?.options
				const disable = listOptions[name]?.disabled
				return (
					<FormSelect
						name={name}
						value={form_data.value[name]}
						required={props?.required}
						onChange={(e) => !props?.readOnly && handleSelect(e, name)}
						options={option}
						feedback={props.feedback}
						invalid={!props?.readOnly && !disable && props?.invalid}
						disabled={props?.readOnly ? props?.readOnly : disable && !form_data.value[disable]}
					/>
				)
			case "radio":
				return (
					<FormRadio
						type={type}
						name={name}
						value={form_data.value[name]}
						required={props?.required}
						feedback={props?.feedback}
						invalid={!props?.readOnly && props?.invalid}
						disabled={props?.readOnly}
					/>
				)
			default:
				return (
					<FormRender
						type={type}
						name={name}
						value={form_data.value[name]}
						required={props?.required}
						feedback={name === "nickname" || name === "uid" ? false : props?.feedback}
						maxLength={props?.maxLength}
						onChange={(e) => !props?.readOnly && handleChange(e, name)}
						invalid={(!props?.readOnly) && props?.invalid}
						disabled={props?.readOnly ? props?.readOnly : name === "phone_number" && !country_dial_code}
					/>
				)
		}
	}

	const displayCol = {
		nickname: "col-12",
		uid: "col-12",
		name: "col-12",
		address: "col-12",
		country: "col-md-6 col-sm-12",
		province: "col-md-6 col-sm-12",
		city: "col-md-6 col-sm-12",
		district: "col-md-6 col-sm-12",
		postal_code: "col-md-6 col-sm-12",
		country_dial_code: "col-3",
		phone_number: "col-9",
		email: "col-12",
		address_name: "col-12",
		id_card_number: "col-12",
	}

	return <div className={displayCol[name]}>{renderType()}</div>
}

export default ListField
